import React, { useState } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Box } from "rebass/styled-components";
import styled, { css } from "styled-components";
import Fixtures from "../Fixtures";
import { Main, Wrapper } from "../Layout";
import PageHeader from "../PageHeader";
import { VisuallyHidden } from "../Utils";
import CreateSquad, { IListTableProps } from "./CreateSquad";
import ElementList from "./ElementList";

const PusherWrap = styled.div`
  overflow-x: clip;
`;

const Pusher = styled.div<IState>`
  position: relative;
  transition: all 300ms;

  ${(props) =>
    props.isSidebarVisible &&
    css`
      transform: translate3d(-100%, 0, 0);

      @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
        transform: none;
      }
    `}
`;

const PusherSecondary = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  transform: translate3d(100%, 0, 0);
  overflow-y: auto;
  padding-top: 2rem;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    position: static;
    transform: none;
    width: calc(100% / 3);
    padding-right: 1rem;
    padding-left: 1rem;
  }

  /* @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 25%;
  } */
`;

interface IProps {
  listTable: (listTableProps: IListTableProps) => React.ReactNode;
  scoreboard: string;
  submitDialog: (handleHide: () => void) => React.ReactNode;
  title: React.ReactNode;
  showListTableAsDefault?: boolean;
  contentTitle: string;
}

interface IState {
  isSidebarVisible: boolean;
}

type Props = IProps & WithTranslation;

const SquadBase = ({
  contentTitle,
  listTable,
  scoreboard,
  showListTableAsDefault,
  submitDialog,
  title,
}: Props) => {
  const [isSidebarVisible, setIsSidebarVisible] = useState<boolean>(false);

  const showListRef = React.useRef<HTMLButtonElement>(null);
  const hideListRef = React.useRef<HTMLButtonElement>(null);
  const replacePlayerRef = React.useRef<HTMLButtonElement>(null);

  const handleShowSidebar = () => setIsSidebarVisible(true);

  const handleHideSidebar = () => setIsSidebarVisible(false);

  const handleTransitionEnd = (e: React.TransitionEvent) => {
    // Just handle the Pusher transition
    if (e.target === e.currentTarget) {
      if (isSidebarVisible) {
        hideListRef.current?.focus?.();
      } else {
        (showListRef.current ?? replacePlayerRef.current)?.focus?.();
      }
    }
  };

  return (
    <PusherWrap>
      <Pusher
        isSidebarVisible={isSidebarVisible}
        onTransitionEnd={handleTransitionEnd}
      >
        <Wrapper>
          <Main>
            <Box mx={2}>
              <VisuallyHidden as="div">
                <PageHeader title={title} children={undefined} />
              </VisuallyHidden>
            </Box>
            <CreateSquad
              contentTitle={contentTitle}
              showListTableAsDefault={showListTableAsDefault}
              listTable={listTable}
              scoreboard={scoreboard}
              showSidebar={handleShowSidebar}
              showListRef={showListRef}
              submitDialog={submitDialog}
              replacePlayerRef={replacePlayerRef}
            />
            <Fixtures />
          </Main>
          <PusherSecondary>
            <ElementList
              contentTitle={contentTitle}
              hideListRef={hideListRef}
              hideSidebar={handleHideSidebar}
            />
          </PusherSecondary>
        </Wrapper>
      </Pusher>
    </PusherWrap>
  );
};

export default withTranslation()(SquadBase);
